import AdminAuctionTile from "./AdminAuctionTile";

export default AdminAuctionTile;
